/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupLoanMembers { 
    userId?: number;
    fullName?: string | null;
    principalAmount?: number;
    interestAmount?: number;
    principalOutStandingAmount?: number;
    lastBilledDueAmount?: number;
    startDate?: string | null;
    endDate?: string | null;
    paymentAmount?: number;
    memberType?: string | null;
    emailId?: string | null;
    phoneNumber?: string | null;
}

